import React from "react";
import PropTypes from "prop-types";
import ContentIsNotIncluded from "./ContentIsNotIncluded";
import ContentIsIncluded from "./ContentIsIncluded";

const SecondStepData = ({ projectData, secondStepData, callSecondStep, toggleAccordion, updateProjectData }) => {

  return (<div>
    {projectData && projectData.content_included ? <ContentIsIncluded callSecondStep={callSecondStep}
                                                                      toggleAccordion={(tab) => toggleAccordion(tab)}
                                                                      updateProjectData={(updateElements) => updateProjectData(updateElements)}
                                                                      projectData={projectData}
                                                                      secondStepData={secondStepData}/> :
      <ContentIsNotIncluded projectData={projectData}
                            secondStepData={secondStepData?.without_content}
                            toggleAccordion={(tab) => toggleAccordion(tab)}
                            updateProjectData={(updateElements) => updateProjectData(updateElements)}
                            callSecondStep={callSecondStep}/>}
  </div>);
};

SecondStepData.propTypes = {
  projectData: PropTypes.object,
  callSecondStep: PropTypes.func,
  toggleAccordion: PropTypes.func,
  updateProjectData: PropTypes.func,
  secondStepData: PropTypes.any
};

export default SecondStepData;
